import React from "react";
import { useNavigate } from "react-router-dom";
import "./not-found.css";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>Page not found!</h1>
        <div className="not-found-404">404</div>
        <button className="go-to-dashboard-button" onClick={handleGoToDashboard}>
          Go to dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;